var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 16.29,
    viewBox: "0 0 16.2 16.29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    d: "M13.46 16.19H2.74A2.68 2.68 0 0 1 .1 13.518v-5.84a2.62 2.62 0 0 1 .88-1.952L6.34.862a2.64 2.64 0 0 1 3.52 0l5.36 4.864a2.6 2.6 0 0 1 .88 1.952v5.84a2.68 2.68 0 0 1-2.64 2.672ZM8.1 1.838a1.3 1.3 0 0 0-.72.24L2.02 6.942a.94.94 0 0 0-.32.816v5.84a1.073 1.073 0 0 0 1.04 1.056h10.64a1.06 1.06 0 0 0 1.04-1.056v-5.84a1.5 1.5 0 0 0-.32-.816L8.74 2.078a.9.9 0 0 0-.64-.24Z",
    "data-name": "Path 3"
  })));
};
export default SvgHouse;